import { v1ApiClient } from '@/services';

import type { GetWorkspaceParams, GetWorkspaceResponse } from '../model/types';

export const getWorkspace = ({
  workspace_id,
}: GetWorkspaceParams): Promise<GetWorkspaceResponse> =>
  v1ApiClient.get(`/workspaces/${workspace_id}`).then((res) => res.data);

export type { GetWorkspaceParams, GetWorkspaceResponse } from '../model/types';
